<template>
    <div>
        <button @click="login" type="submit" class="btn btn-primary green-btn mb-5" :class="isMyBeauty ? 'sign-in-btn' : ''">
            <div v-if="showLoader" class="spinner-border white-spinner" role="status" aria-label="Spinning">
                <span class="visually-hidden">Loading...</span>
            </div>
            <div v-if="!showLoader">Sign in</div>
        </button>
    </div>
</template>

<script setup>
    /* eslint-disable */
    import { ref, computed, watch, inject } from 'vue'
    import { useStore } from 'vuex'
    import { useRoute, useRouter } from 'vue-router'
    import useVuelidate from '@vuelidate/core'
    import { required, email as emailValidator } from '@vuelidate/validators'
    import digitalApi from '@/services/DigitalApiClient.js'
    import { getOTPMethods, sendOTP } from '@/services/2FAClient.js'

    const emit = defineEmits(['passLoginErrorMsg'])

    // Props
    const props = defineProps(['source', 'prefillEmail'])

    // Store and Router
    const store = useStore()
    const router = useRouter()
    const route = useRoute()

    // State
    const email = ref(props.prefillEmail || '')
    const password = ref('')
    const showLoader = ref(false)
    const emailCN = ref(false)
    const errorNotification = ref('')
    const LoginErrorMsg = ref(false)
    const isMyBeauty = inject('isMyBeauty', computed(() =>
        route.params.isMyBeauty === 'mybeauty' ||
        route.query.isMyBeauty === 'true' ||
        route.query.isMyBeauty === true
    ))

    // Vuelidate rules
    const rules = computed(() => ({
        email: { required, email: emailValidator },
        password: { required }
    }))
    const v$ = useVuelidate(rules, { email, password })

    // Watch for prop changes
    watch(() => props.prefillEmail, val => { email.value = val })

    // Methods
    function checkCNPhoneInput() {
        //LOGIC:
        // Display error message if any of the following are true
        //typed number starts with 0086 AND there is no @ or . included
        //typed number starts with +86 AND the input does NOT include an @ or .
        //typed number starts with 13, 15, or 18 AND there is no @ or . included
        if
            (
            (email.value.startsWith('0086') || email.value.startsWith('+' + 86) || email.value.startsWith(13) || email.value.startsWith(15) || email.value.startsWith(18))
            &&
            (!email.value.includes('@') || !email.value.includes('.'))

        ) {
            emailCN.value = true;
            errorNotification.value = "We're sorry. We do not support logging in with a phone number here. To access your Rewards information please contact our Chinese Customer Service Team on <a href='tel: +86 21 6154 6680'>+86 21 6154 6680.</a>";
        } else {
            emailCN.value = false
        }
    }

    async function retrieveUser(result) {
        digitalApi.getUser().then((resultGetUser) => {
            if (result === -1 || result === 0) {
                displayLoginError('There was a problem accessing your account. Please call our Customer Service team on +44 (0)20 7730 1234');
            }
            if (isMyBeauty.value && !resultGetUser.isMyBeautyMember) {
                store.dispatch("savePwd", password.value);
                router.push({ name: 'JoinMyBeauty', params: { user: resultGetUser } });
            }
            else if (resultGetUser.isRewards === false) {
                router.push({ name: 'JoinRewardsHome', params: { user: resultGetUser, source: props.source } });
            } else {
                router.push({ name: 'DownloadAfterSignIn' });
            }
        }).catch(() => {
            showLoader.value = false;
        });
    }

    function tryAndProceedToVerification() {
        getOTPMethods().then((response) => {
            if (response.status === 200) {
                store.dispatch('saveVerificationMethods', response.data.Items);
                if (response.data.Items.length === 1) {
                    // Only has email option, send code to email and bypass selection screen
                    sendOTP("email")
                        .then((response) => {
                            store.dispatch("saveTokenRef", { tokenRef: response.data.otpRef, verificationMethod: "email" })
                            router.push({ name: 'VerifyOTP' });
                        })
                        .catch((error) => {
                            if (error.response.status === 400 || error.response.status === 401) {
                                store.dispatch("reset");
                                router.push("/");
                            } else {
                                displayLoginError("We’re sorry that didn’t work. Please try again.")
                            }
                        })
                } else {
                    // Has mulitple available verification methods, go to selection screen
                    router.push({ name: 'SelectVerificationMethod' });
                }
            }
        })
            .catch((error) => {
                if (error.response && error.response.status === 404) {
                    displayLoginError('We’re sorry that didn’t work. Please try again.');
                }
                else if (error.response && error.response.status === 409) {
                    displayLoginError('There was a problem accessing your account. Please call our Customer Service team on +44 (0)20 7730 1234');
                }
                else if (error.response && error.response.status === 400) {
                    displayLoginError('We’re sorry that didn’t work. Please try again.');
                }
                else {
                    displayLoginError('We’re sorry that didn’t work. Our engineers are currently working on the issue. Please try again later.');
                }
            });
    }
    function displayLoginError(message) {
        showLoader.value = false;
        LoginErrorMsg.value = true;
        errorNotification.value = message;
        if (window.innerWidth >= 992) {
            emit('passLoginErrorMsg', errorNotification.value)
        }
    }
    function login() {
        showLoader.value = true;

        store.dispatch("signin");
        //this.$v.$touch();

        /*if (!this.$v.$invalid) {
          let scope = isMyBeauty ? "mybeauty" : null;
          digitalApi.authUser(email.value, password.value, scope).then((result) => {
            if (result === 1) {
              getOTPStatus().then((response) => {
                if (response.status === 202) {
                  this.retrieveUser(result);
                }
              })
              .catch((error) => {
                if (error.response.status === 412 || error.response.status === 401) {
                  this.tryAndProceedToVerification();
                }
              });
            } else if (result === -1) {
                displayLoginError('Your email address or password were not correct. Please try again.');
            } else if (result === 7 || result === 11 || result === 12) {
                displayLoginError('There was a problem accessing your account. Please call our Customer Service team on +44 (0)20 7730 1234');
            } else if (result === 9) {
                digitalApi.sendRemindMeEmail(this.email)
                .then(() => this.$router.push({ name: 'VerifyAccount', params:{email: this.email} }))
                .catch((error) => {
                  if (error.response && error.response.status === 423) {
                    displayLoginError('There was a problem accessing your account. Please call our Customer Service team on +44 (0)20 7730 1234');
                  } else {
                    displayLoginError('We apologise, something went wrong. Please try again in a short while');
                  }
                })

            } else if (result === 14) {
                displayLoginError('Your email address or password were not correct. Please try again.');
            } else if (result === 15) {
                displayLoginError("We're sorry.We do not support logging in with a phone number here.To access your Rewards information please contact our Chinese Customer Service Team on + 86 21 6154 6680.");
            } else if (result === 429) {
              displayLoginError("Too many failed attempts. For security reasons we've locked your account for 5 minutes. Please try again later.")
            } else if (result === 417 || result === 420) {
              displayLoginError("There was a problem accessing your account. Please call our Customer Service team on +44 (0)20 7730 1234")
            } else {
                console.log("Unknown Error");
                console.log(result);
                displayLoginError('We apologise, something went wrong. Please try again in a short while.');
            }
          }).catch((error) => {
            if (error.response?.data.custom_error && error.response.data?.custom_error.error === 429) {
              displayLoginError("Too many failed attempts. For security reasons we've locked your account for 5 minutes. Please try again later.")
            }
            displayLoginError('We apologise, something went wrong. Please try again in a short while');
            //this.$appInsights.trackException({exception: error});
          });

        } else if (this.$v.$invalid) {
          displayLoginError('Please enter valid user details');
        } else {
          displayLoginError('Please enter an email address & password');
        }*/


    }
</script>

<style lang="scss" scoped>
    .sign-in-btn {
        @media screen and (max-width: 1199px) and (min-width: 992px) {
            margin-top: 69px;
        }

        @media screen and (min-width: 1200px) {
            margin-top: 47px;
        }
    }

    #gigya-error-msg-gigya-login-form-password {
        margin-top: 0 !important;
    }
</style>
